import axiosInstance from "@/config/axios";
import axios from "axios";

// import { AUTH_KEY, CHAT_ENDPOINT, CHAT_SECRET_KEY } from "@/constants";
import { AUTH_KEY, CHAT_ENDPOINT, CHAT_SECRET_KEY } from "@/components/constants";

// Add a new function to handle file uploads directly with a File object
export const uploadFile = async (file: File) => {
    const userDataString = localStorage.getItem(AUTH_KEY);

    try {
        const fileData = file;
        const fileType = file.type;
        // const fileName = file.name;
        const fileName = file.name.split('.').slice(0, -1).join('.');


        // Make the request to get the presigned URL
        const response = await axios.post(`${CHAT_ENDPOINT}/api/presigned-url`, {
            type: fileType,
            filename: fileName
        }, {
            headers: {
                Authorization: `Bearer ${CHAT_SECRET_KEY}`,
            },
        });

        console.log("Response Upload", response)

        // Check if we have the necessary data
        if (!response?.data?.url) {
            throw new Error("Invalid response from server: Missing presigned URL");
        }

        // Upload the file to the presigned URL
        await axios({
            method: "put",
            url: response.data.url,
            data: fileData,
            headers: {
                "Content-Type": fileType,
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers":
                    "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            },
        });

        // Return the file information
        return {
            fileName: response.data.filename,
            fileUrl: response.data.url || `https://chat-api-bucket-lailaolab.s3.ap-southeast-1.amazonaws.com/images/${response.data.data.fileName}`
        };
    } catch (error) {
        console.error("Upload file error:", error);
        throw error;
    }
};